import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment/moment';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import NovoTransportador from './NovoTransportador';
import FichaTransportador from './FichaTransportador';

//Helpers
import { showMessage } from '../../../helpers/message';
import { getSessionCookie } from '../../../helpers/cookies';

//Api
import transportador_api from '../../../api/transportador_api';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../context/auth';

export default function Transportadores({ permissao }) {
    const { setupVariavel } = useAuth();

    //Estado de controle dos headers da tabela
    const [headers, setHeaders] = useState([
        { value: "Fantasia", objectValue: "fantasia", align: "left" },
        { value: "Razão Social", objectValue: "razao", align: "left" },
        { value: "CNPJ", objectValue: "cnpj", align: "left" },
        { value: "Status", objectValue: "situacao", align: "left" },
        { value: "Veiculos Credenciados", objectValue: "qtdVeiculos", align: "right" },
        { value: "Modalidade de coleta", objectValue: "modalidades", align: "left", options: { display: false } },
    ]);

    //Headers com filtro de credenciamento
    const headersCredenciamento = [
        { value: "Fantasia", objectValue: "fantasia", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        { value: "Validade do credenciamento", objectValue: "validadeCredenciamento", align: "left" },
        { value: "Veiculos Credenciados", objectValue: "qtdVeiculos", align: "right" },
        { value: "Contratos", objectValue: "contratos", align: "left" },
    ];

    //Dados do usuario logado
    const usuario = getSessionCookie();

    //Variavel para navegação
    const navigate = useNavigate();

    //Variavel para pegar dados que possam vir no state da rota
    const location = useLocation();

    // guarda a lista de todos os transportadores
    const [transportadores, setTransportadores] = useState([]);

    // guarda o estado para o botão de novo transportador
    const [novo, setNovo] = useState(false);

    // guarda o estado para os botão de visualização da ficha
    const [ficha, setFicha] = useState(null);

    // guarda o estado para a exibição do loading na tela
    const [loading, setLoading] = useState(false);

    // carrega a lista de todos os transportadores
    const loadTransportadores = () => {
        setLoading(true);
        transportador_api.GetList(location.state && location.state.credenciamento ? location.state.credenciamento : null).then(response => {
            response.data = response.data.map(value => {
                value.validadeCredenciamento = moment(value.validadeCredenciamento).format("DD/MM/YYYY");
                return value;
            })
            setTransportadores(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error"))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadTransportadores();
        if (location.state && location.state.credenciamento)
            setHeaders(headersCredenciamento); 
    }, []);



    // retorna a ficha caso tenha algo armazenado em seu estado
    if (ficha) {
        return <FichaTransportador btnVoltar={() => {
            loadTransportadores();
            setFicha(null);
        }} id={ficha} permissao={permissao} integracaoCadastros={setupVariavel?.integracaoCadastros}/>;
    }

    // retorna a tela de novo caso tenha algo armazenado em seu estado
    if (novo) {

        return <NovoTransportador btnVoltar={() => {
            loadTransportadores();
            setNovo(false);
        }} />;
    }
    const getTitle = () => {
        if (location.state && location.state.credenciamento)
            return "Credenciamento " + location.state.credenciamento.toLowerCase();


        return null;
    }

 
    //Ações  da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];
    //retorna a tela de listagem
    return (
        <>
            {loading && <Loading />}
            <MainCard
                title={getTitle()}
                btnVoltarInTop={location.state && location.state.credenciamento
                    ? () => navigate(-1)
                    : null} noCard 
                btnCadastro={permissao === "Editar" 
                                && (usuario.acesso.sigla === "GS")
                                && (usuario.ambiente != "Privado")                                
                                && !setupVariavel?.integracaoCadastros 
                                && !(location.state && location.state.credenciamento) ? "Adicionar" : null}
                onClickBtnCadastro={() => setNovo(true)}

            >


                <div className="mt-4">
                    <TabelaListagem actions={actions} headers={headers} items={transportadores} title={`Lista de transportadores`} options={{ print: false, search: true, pagination: true }} />
                </div>
            </MainCard>
        </>
    )
}
